// NavBar.js
import React from 'react';
import styles from './SongPage.module.scss';
import Close from '../Icons/Close.js';
import Skip from '../Icons/Skip.js';
import Down from '../Icons/Down.js';
import HeartLoader from '../HeartLoader';

const NavBar = ({
  songDetails,
  navbarState,
  onClose,
  onSkip,
  onMinimize,
  isLoadingNextSong,
}) => {
  return (
    <div className={styles.navBar}>
      <div className={styles.navBarTitle}>
        <div className={`${styles.navBarTitleContent} ${styles[navbarState]}`}>
          <div className={styles.defaultTitle}>A Good Song</div>
          <div className={styles.scrolledTitle}>
            <div className={styles.navBarSong}>{songDetails?.songName}</div>
            <div className={styles.navBarArtist}>{songDetails?.songArtist}</div>
          </div>
        </div>
      </div>
      <div className={styles.navBarButtons}>
        <div
          onClick={!isLoadingNextSong ? onSkip : null}
          role="button"
          tabIndex={0}
          onKeyDown={(e) => e.key === 'Enter' && !isLoadingNextSong && onSkip()}
          className={styles.skipButton}
        >
          {isLoadingNextSong ? (
            <HeartLoader progress={100} />
          ) : (
            <Skip fill="#404040" />
          )}
        </div>
        {onMinimize && (
          <div
            onClick={onMinimize}
            role="button"
            tabIndex={0}
            onKeyDown={(e) => e.key === 'Enter' && onMinimize()}
            className={styles.minimizeButton}
            aria-label="Minimize player"
          >
            <Down fill="#404040" />
          </div>
        )}
        <div
          onClick={onClose}
          role="button"
          tabIndex={0}
          onKeyDown={(e) => e.key === 'Enter' && onClose()}
          className={styles.closeButton}
        >
          <Close fill="#404040" />
        </div>
      </div>
    </div>
  );
};

export default NavBar;
